import LogsAdmin from "../components/LogsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin.css";
import "../styles/logs.css";

const AdminLogs = () => {
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="logs"
                backTo="/admin"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "logs" },
                ]}
            />
            <LogsAdmin />
        </div>
    );
};

export default AdminLogs;
